import { el } from '../../core/dom.js';
import { button } from '../../components/button.js';
import { dashboardHref, notFoundCopy } from './model.js';

/**
 * Dedicated 404 screen (plan 4 R11). Kept inside the app shell.
 * @param {{ productId?: string, path?: string }} [opts]
 */
export function renderNotFound(opts) {
  const productId = (opts && opts.productId) || '';
  const copy = notFoundCopy(opts && opts.path);
  return el('div', { class: 'st' },
    el('div', { class: 'st-card' },
      el('span', { class: 'st-kicker lbl' }, copy.kicker),
      el('h1', { class: 'st-title' }, copy.title),
      el('p', { class: 'st-body' }, copy.body),
      button(copy.actionLabel, {
        variant: 'primary',
        href: dashboardHref(productId),
      })));
}
